import React, { useState, useEffect } from 'react';
import api from '../../api';
import { FaChartBar, FaSave, FaTrash, FaPlus } from 'react-icons/fa';
import styles from './Admin.module.css';

const AdminStatistics = () => {
  const [stats, setStats] = useState([]);
  const [form, setForm] = useState({ id: 0, value: '', suffix: '', label: '', description: '', iconName: 'FaSolarPanel', colorHex: '#00D084' });
  

  useEffect(() => { fetchStats(); }, []);
  const fetchStats = async () => { const res = await api.get('/Statistics'); setStats(res.data); };

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
   await api.post('/Statistics', form);
    fetchStats();
    setForm({ id: 0, value: '', suffix: '', label: '', description: '', iconName: 'FaSolarPanel', colorHex: '#00D084' });
  };

  const handleDelete = async (id) => {
    if(!window.confirm("Delete?")) return;
    await api.delete(`/Statistics/${id}`);
    fetchStats();
  };

  return (
    <div className={styles.formCard} style={{maxWidth:'800px'}}>
      <h3 style={{color:'#4ade80'}}><FaChartBar /> Manage Statistics</h3>
      
      {/* Form */}
      <form onSubmit={handleSubmit} style={{marginBottom:'30px', borderBottom:'1px solid #444', paddingBottom:'20px'}}>
        <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:'10px'}}>
          <input className={styles.formInput} name="value" placeholder="Value (e.g. 500)" value={form.value} onChange={handleChange} required />
          <input className={styles.formInput} name="suffix" placeholder="Suffix (e.g. +)" value={form.suffix} onChange={handleChange} />
          <input className={styles.formInput} name="label" placeholder="Label" value={form.label} onChange={handleChange} required />
          <input className={styles.formInput} name="description" placeholder="Description" value={form.description} onChange={handleChange} />
          <select className={styles.formInput} name="iconName" value={form.iconName} onChange={handleChange}>
            <option value="FaSolarPanel">Solar Panel</option>
            <option value="FaBolt">Bolt (Capacity)</option>
            <option value="FaMapMarkerAlt">Map Marker</option>
            <option value="FaAward">Award</option>
          </select>
          <div style={{display:'flex', alignItems:'center', gap:'10px'}}>
            <input type="color" name="colorHex" value={form.colorHex} onChange={handleChange} style={{height:'40px'}} />
            <span style={{color:'white'}}>{form.colorHex}</span>
          </div>
        </div>
        <button className={styles.primaryBtn} style={{marginTop:'10px'}}>
          <FaSave /> {form.id === 0 ? 'Add Stat' : 'Update Stat'}
        </button>
      </form>

      {/* List */}
      <div>
        {stats.map(s => (
          <div key={s.id} style={{background:'rgba(255,255,255,0.05)', padding:'10px', marginBottom:'10px', borderRadius:'5px', display:'flex', justifyContent:'space-between'}}>
            <div style={{color:'white'}}>
              <strong>{s.value}{s.suffix}</strong> - {s.label}
            </div>
            <div style={{display:'flex', gap:'10px'}}>
              <button onClick={() => setForm(s)} style={{background:'transparent', border:'none', color:'#4ade80'}}>Edit</button>
              <button onClick={() => handleDelete(s.id)} style={{background:'transparent', border:'none', color:'#ef4444'}}><FaTrash /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default AdminStatistics;